export default {
    NO_ITEM_SELECTED: 'Kailangan mo pumili ng item para makapag enchant.',
    CANNOT_ENCHANT: 'Ang napili mong item ay di pwedeng ma enchant.',
    NO_SHARD: 'Kailangan mo ng shard upang ma enchant and item na ito',
    FAILED_ENCHANT: 'Triny mong mag enchant pero walang nangyare.',
    SUCCESSFUL_ENCHANT: 'Matagumpay mong na enchant ang iyong item.'
} as const;
